export default __webpack_public_path__ + "static/media/redies.3926f32d.svg";